import React, { FunctionComponent, PropsWithChildren, useState } from 'react'
import { Accordion, Text, Flex } from '@afterpaytouch/core'
import { useCheckoutSizes } from '../../../../../utils/responsive'
import { Money } from '@afterpay/types'
import { useMoney } from '../../../../../component/Money/useMoney'
import { useAppRouter } from '../../../../../state/hooks'
import styles from './style.module.css'

type GroupContainerProps = {
  name: string
  amount: Money
  expandable?: boolean
}

export const GroupContainer: FunctionComponent<PropsWithChildren<GroupContainerProps>> = (props): JSX.Element => {
  const { name, amount, children, expandable = false } = props
  const [isOpen, setIsOpen] = useState(false)
  const { textSize } = useCheckoutSizes()
  const { locale } = useAppRouter()
  const { formatMoney } = useMoney({
    locale,
    currency: amount?.currency,
  })

  if (!expandable) {
    return (
      <Flex direction='column'>
        <Flex justifyContent='space-between'>
          <Text size={textSize} bold>
            {name}
          </Text>
        </Flex>
        <div className={styles.container}>{children}</div>
      </Flex>
    )
  }

  return (
    <Accordion expanded={isOpen} onChange={setIsOpen}>
      <Accordion.Button>
        <Flex justifyContent='space-between'>
          <Text size={textSize} bold>
            {name}
          </Text>
          {!isOpen && (
            <Text size={textSize} bold>
              {formatMoney(amount.amount)}
            </Text>
          )}
        </Flex>
      </Accordion.Button>
      <Accordion.Details>{children}</Accordion.Details>
    </Accordion>
  )
}
